import { api } from "@/builders/axios";
import { AdminUserProfile } from "@/builders/types/admin-user-profile";
import { FilterParams } from "@/builders/types/filter-params";
import {
  CreateOrganizationData,
  OrganizationList,
} from "@/builders/types/organization";
import { link } from "./link";

const get = function (params?: FilterParams) {
  return api
    .get<OrganizationList>("organizations", { params })
    .then(({ data }) => data);
};

const post = function (data: CreateOrganizationData) {
  return api.post("organizations", data);
};

const put = function (variables: {
  link: string;
  data: CreateOrganizationData;
}) {
  const { link, data } = variables;
  return api.put(`/organizations/${link}`, data);
};

const profile = function (link: string) {
  return api
    .get<{ data: AdminUserProfile }>(`organizations/${link}`)
    .then(({ data }) => data);
};

export const organizations = {
  get,
  put,
  post,
  link,
  profile,
};
